import { useI18n } from 'vue-i18n'
import type { TR } from '@/i18n/i18n-global'

export function useTr() {
    // re-exporting $t from i18n with strict types
    // eslint-disable-next-line
    const { t } = useI18n()
    return t as TR
}
